import { render, staticRenderFns } from "./ProductCategoryRelation.vue?vue&type=template&id=44a60498&"
import script from "./ProductCategoryRelation.vue?vue&type=script&lang=js&"
export * from "./ProductCategoryRelation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports